import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * SPA pageview tracker for GA4.
 *
 * Mount inside <Router> so useLocation works. Fires a `page_view` event to
 * gtag on every route change. Initial gtag.js load + config happens in
 * src/index.js with `send_page_view: false`, so this is the single source
 * of truth for pageviews — no double-counting on initial load.
 *
 * Silent no-op when REACT_APP_GA4_ID isn't set (dev / preview builds).
 */
export default function GA4PageView() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!process.env.REACT_APP_GA4_ID) return;
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}
